/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import {JOBDETAIL, ROUTE_JOB_DETAIL} from '@constants';
import {getWindow} from 'ssr-window';
import useInterceptor from '@jobseeker/common-core/hooks/useInterceptor';
import {
  fetchJobInsights,
  getMagicRank,
} from '@jobseeker/common-core/reducers/job/thunkServices/jobdetail';
import {saveJob} from '@jobseeker/common-core/reducers/job/thunkServices/jobfeed';
import jobDetailService from '@jobseeker/common-core/services/jobdetail.service';
import surveyService from '@jobseeker/common-core/services/survey.service';
import {
  getExperienceIndex,
  getKeyFromPath,
  openUrl,
  deferTask,
} from '@jobseeker/common-core/utils/common';
import {getLocationString} from '@jobseeker/feature-job/utils';
import Alert from '@jobseeker/lotus/components/Alert';
import DialogWithBottomSheet from '@jobseeker/lotus/components/DialogWithBottomSheet';
import Dialog from '@jobseeker/lotus/components/Dialog';
import ImageThumbnail from '@jobseeker/lotus/components/ImageThumbnail';
import Loader from '@jobseeker/lotus/components/Loader';
import Button from '@jobseeker/lotus/elements/ButtonV2';
import ProChip from '@jobseeker/lotus/elements/Pro';
import Tooltip from '@jobseeker/lotus/elements/Tooltip';
import {VersionVariants} from '@jobseeker/lotus/enums/variants';
import {JobDetail as JD} from '@jobseeker/common-core/types';
import userService from '@jobseeker/common-core/services/user.service';

import {
  Box,
  Card,
  Grid,
  IconButton,
  Link,
  Modal,
  Skeleton,
  Typography,
  useScrollTrigger,
} from '@mui/material';
import kebabCase from 'lodash/kebabCase';
import moment from 'moment';
import JobPostingJsonLd from '@jobseeker/feature-job/components/JobPostingSchema';
import dynamic from 'next/dynamic';
import {useRouter} from 'next/router';
import {Dispatch, memo, useEffect, useMemo, useRef, useState} from 'react';
import {shallowEqual, useSelector} from 'react-redux';
import InjectSearchOverlay from '@components/SearchInjection';
import {
  AIPixel,
  ConfVerified,
  DefaultJobLogo,
  Dot,
  RupeeGrey,
  SurveyBackground,
  Survey as SurveyImg,
  ThreeStar,
  ThumbUp,
  VerifiedIcon,
} from '@jobseeker/lotus/assets/icons';
import {
  useIsCustomWidth,
  useIsLargeDevice,
  useWrappedTheme,
} from '@jobseeker/lotus/hooks/common';
import {
  getNestedProperty,
  getOldLink,
  getProLink,
  isCSR,
} from '@jobseeker/lotus/utils';
import {Image} from '@jobseeker/lotus/components/Image';
// import {userService} from '@jobseeker/common-core/services';
import {fetchSimilarJobs} from '@jobseeker/common-core/reducers/job/thunkServices/jobfeed';
import {handleTracking, TrackEventUBA} from '@jobseeker/common-core/utils';
import FloatingApplyButton from '@jobseeker/feature-job/components/FloatingApplyButton';
import {additionalInfoIconMap} from '@jobseeker/feature-job/components/JobFeed/V2';
import {applyOnJob, handleJobApply} from '@utils/applyJobUtils';
import debounce from 'lodash/throttle';
import ReactPlayer from 'react-player';

import type {Survey as SurveyType} from '@jobseeker/common-core/services/types';
import type {JobDetail as JB} from '@jobseeker/common-core/stateModels/job/jobdetail.models';
import type {AppState} from '@jobseeker/common-core/types';
import type {QuestionType} from '@jobseeker/lotus/components/SurveyQuestion/types';
import ProfileUpdateModal from '@jobseeker/feature-profile/components/ProfileUpdateModal';
import {
  LinkedInBottomSheetComponent,
  LinkedInEmailCaptureComponent,
} from '@components';

import {
  Wrapper,
  CompanyAwards,
  CompanyJobs,
  CompanyHighLights,
  AboutUsSection,
  JDBrandingBanner,
  EmployerBenefits,
  CompanyReview,
  StickyJobNavigation,
  Clients,
  CompanyInsights,
} from '@jobseeker/lotus/components';
import {ImageWithFallback} from '@jobseeker/lotus/components/JobList/V2';
// import BrandedJD from '@components/BrandedJD';
import {BrandedJDData} from '@jobseeker/lotus/components';
import {jobfeedService} from '@jobseeker/common-core/services';
import {useAlertCallback, useInView} from '@jobseeker/lotus/hooks';
import {setCookie} from 'cookies-next';
import cookie from 'cookie';
import {getRandomColor} from '@jobseeker/lotus/theme';
import {formatSalary} from '@jobseeker/lotus/utils';
import {COOKIE_LOGIN_AUTH} from '@jobseeker/common-core/constants';
const window = getWindow();

type JobDetailLayoutProps = {
  dispatch: Dispatch<any>;
  jobId: string;
  showFeatured: boolean;
  showLearning: boolean;
  refInfo?: string;
  variant?: VersionVariants;
  brandedData: BrandedJDData;
  brandedJD?: number;
  similarJobs?: JD[];
  userIdSSR?: number;
  showFreeProBannerToday?: boolean;
};

const JobOverviewCard = dynamic(
  () => import('@jobseeker/lotus/components/JobOverviewCard'),
  {
    loading: () => <Loader />,
  }
);

const ApplyJobDialog = dynamic(
  () => import('@jobseeker/feature-job/components/ApplyJobDialog'),
  {
    loading: () => <Loader />,
    ssr: false,
  }
);

const ReportJobDialog = dynamic(
  () => import('@jobseeker/client-harness/components/JobHarness/ReportJob'),
  {
    loading: () => <Loader />,
    ssr: false,
  }
);

const ResumePopup = dynamic(
  () =>
    import('@jobseeker/client-harness/components/ProfileHarness/ResumePopup'),
  {
    loading: () => <Loader />,
    ssr: false,
  }
);

const JobDetailCard = dynamic(
  () => import('@jobseeker/lotus/components/JobDetailCard'),
  {
    loading: () => <Loader />,
  }
);

const Diversity = dynamic(
  () => import('@jobseeker/feature-ads/components/Diversity'),
  {
    loading: () => <Loader />,
  }
);

const AdsPanelHarness = memo(
  dynamic(
    () => import('@jobseeker/client-harness/components/AdsHarness/AdsPanelV2'),
    {
      loading: () => (
        <Card
          sx={{
            borderRadius: 4,
            px: 1.5,
            py: 2,
          }}
        >
          <Skeleton
            variant="rounded"
            width="100%"
            height={2040}
            sx={{
              borderRadius: 2,
            }}
          />
        </Card>
      ),
      ssr: false,
    }
  )
);

const JobfeedHarness = dynamic(
  () => import('@jobseeker/client-harness/components/JobHarness/JobfeedV2'),
  {
    loading: () => <Loader />,
  }
);

const LoginForm = dynamic(
  () =>
    import(
      '@jobseeker/client-harness/components/AuthenticationHarness/AuthForm'
    ),
  {
    loading: () => <Loader />,
    ssr: false,
  }
);

const InsightsModal = dynamic(
  () => import('@jobseeker/feature-job/components/InsightsModal/V2'),
  {
    loading: () => <Loader />,
    ssr: false,
  }
);

const JobStatusBar = dynamic(
  () => import('@jobseeker/feature-job/components/JobStatusBanner'),
  {
    loading: () => <Loader />,
    ssr: false,
  }
);

const JobDetailEmpty = dynamic(() => import('@components/Empty/Jobdetail'), {
  loading: () => <Loader />,
});

const ProMembershipPlanPopUp = dynamic(
  () =>
    import(
      '@jobseeker/client-harness/components/PaymentHarness/ProMembershipPopup'
    ),
  {
    loading: () => <Loader />,
  }
);

const Survey = dynamic(
  () => import('@jobseeker/feature-ads/components/Survey'),
  {
    loading: () => <Loader />,
    ssr: false,
  }
);

const DownloadAppJobdetail = dynamic(
  () => import('@jobseeker/lotus/components/DownloadAppJobdetailAndCatogary'),
  {
    ssr: false,
  }
);

const JobDetail = ({
  dispatch,
  jobId,
  showFeatured,
  showLearning,
  refInfo,
  variant = VersionVariants.VERSION_TWO,
  brandedData,
  brandedJD,
  similarJobs,
  userIdSSR,
  showFreeProBannerToday,
}: JobDetailLayoutProps) => {
  const [saved, setSaved] = useState(false);
  const [loginOpen, setLoginOpen] = useState(false);
  const [insightsOpen, setInsightsOpen] = useState(false);
  const [loginRedirect, setLoginRedirect] = useState<any>(undefined);
  const [savingJob, setSavingJob] = useState(false);
  const [openReportJob, setOpenReportJob] = useState(false);
  const [openResumeBanner, setOpenResumeBanner] = useState(false);
  const [isApplying, setIsApplying] = useState(false);
  const [applyJobDialogState, setApplyJobDialogState] = useState(false);
  const [followup, setFollowedUp] = useState(false);
  const [resumeBannerSuccess, setResumeBannerSuccess] = useState(false);
  const [showSurvey, setShowSurvey] = useState(false);
  const [surveyQuestions, setSurveyQuestions] = useState<QuestionType[]>([]);
  const [currQuestion, setCurrQuestion] = useState<QuestionType>(
    surveyQuestions[0]
  );
  const [showProMembershipPrompt, setShowProMembershipPrompt] = useState(false);
  const [openConfJobDialog, setOpenConfJobDialog] = useState(false);

  // Individual expansion state management for each section
  const [jobOverviewExpanded, setJobOverviewExpanded] = useState(false);
  const [brandedBenefitsExpanded, setBrandedBenefitsExpanded] = useState(false);
  const [companyJobsExpanded, setCompanyJobsExpanded] = useState(false);
  const [companyHighlightsExpanded, setCompanyHighlightsExpanded] =
    useState(false);
  const [isPro, setIsPro] = useState<any>(null);
  const [isProLoading, setIsProLoading] = useState(true);

  const toggleJobOverview = () => setJobOverviewExpanded(prev => !prev);
  const toggleBrandedBenefits = () => setBrandedBenefitsExpanded(prev => !prev);
  const toggleCompanyJobs = () => setCompanyJobsExpanded(prev => !prev);
  const toggleCompanyHighlights = () =>
    setCompanyHighlightsExpanded(prev => !prev);

  const theme = useWrappedTheme();
  const router = useRouter();

  useEffect(() => {
    if (userIdSSR != -1) return;
    if (router?.query?.showLogin === 'true') {
      setLoginOpen(true);
    }
  }, [router?.query?.showLogin]);

  const jdQueryParams = {
    ref: (router.query.ref as string) || '',
    jobPos: (router.query.jobPos as string) || '',
  };
  const isSmall = useIsCustomWidth('sm');
  const isMedium = useIsCustomWidth('md');
  const page = useSelector((state: AppState) => state.app.page, shallowEqual);

  const isAppIimjobs = process.env.NEXT_PUBLIC_APP_NAME === 'iimjobs';

  const {
    header: {
      meta: {tabsList},
    },
    jobfeed: {jobInfoKeyElements},
    proMembership,
  }: any = useInterceptor();

  let applyJobDialogFormData = {};
  const jobInfo: JB | any = useSelector((state: AppState) => state.jobDetail);
  const jobCategory = useMemo(() => {
    const tags = [];
    const categoryId = jobInfo.categoryId;
    for (let i = 0; i < tabsList.length; i++) {
      if (tabsList[i]?.dataId == categoryId) {
        return tabsList[i];
      }
      tags.push(...tabsList[i].menu);
    }

    for (let j = 0; j < tags.length; j++) {
      if (tags[j].dataId == categoryId) {
        return tags[j];
      }
    }
  }, [jobInfo.categoryId]);

  const {isLoggedIn, userId} = useSelector(
    (state: AppState) => state.auth,
    shallowEqual
  );
  const userData = useSelector((state: AppState) => state.user, shallowEqual);
  const {
    profile: {
      email,
      // audioPath,
      // videoPath,
      resumeUpdated,
      isShortlisted,
      coverLetterId,
      settings,
      proMembershipFeatures,
    },
    profileLoading,
  } = userData;

  const isStatusChangeCohortUser =
    typeof proMembershipFeatures?.statusChange === 'boolean'
      ? proMembershipFeatures.statusChange
      : undefined;

  useEffect(() => {
    const checkProUser = async () => {
      try {
        setIsProLoading(true);
        const proRes = await userService.checkPro('checkpro');
        if (proRes) {
          setIsPro(proRes?.pro ?? false);
          setIsProLoading(false);
          dispatch({type: 'Auth/set_pro', payload: proRes?.pro ?? false});
        }
      } catch (err: any) {
        console.error('Error while checking pro membership:', err?.message);
        setIsPro(false);
        setIsProLoading(false);
        dispatch({type: 'Auth/set_pro', payload: false});
      }
    };
    checkProUser();
  }, []);

  const openInsightsDialog = () => {
    deferTask(() => {
      if (!isLoggedIn) {
        performLogoutAction();
        setLoginRedirect('openInsightsDialog');
        return;
      }

      if (isPro) {
        dispatch(
          fetchJobInsights({
            userId: userId,
            jobId: jobId,
          })
        );
      }

      setInsightsOpen(true);
      handleTracking('prostatusview', {
        event_category: 'insightpopup',
        UserId: sessionStorage.getItem('userId') || 'NA',
        Device: sessionStorage.getItem('device') || 'desktop',
        Device_Type: sessionStorage.getItem('deviceType') || 'web',
        Status: sessionStorage.getItem('status') || 'LoggedOut',
        Origin: router.pathname,
        Type: 'view',
        CompanyId: jobInfo?.companyData?.companyId,
      });
      TrackEventUBA('jdPageClick', 'click', {
        ref: router.query.ref || '',
        pageName: 'Job Description Page',
        jobID: jobInfo.id,
        jobVersion: '',
        jobRef: getKeyFromPath('ref') || '',
        jobPos: router.query.jobPos || '',
        page: 'JD',
        section: 'Insights',
        sessionUsername: sessionStorage.getItem('userId') || '',
        membershipStatus: isPro ? 'Pro' : 'No Membership',
      });
    });
  };

  const routeToJobDetail = (jobSlug: string, jobId: string | number) => {
    openUrl(`${ROUTE_JOB_DETAIL}/${jobSlug}-${jobId}`);
  };

  const jobFeedStore = useSelector((state: AppState) => state.job);

  const applyJobDialogCallback = () => {
    // return;
    handleTracking('ClickConfirmAndApply', {
      event_category: 'Job',
      Origin: router.pathname,
      Source: 'JobDescription',
      CategoryId: jobInfo.categoryId,
      JobId: jobInfo.id,
      RecruiterId: jobInfo.recruiter?.recruiterId,
      UserId: sessionStorage.getItem('userId') || 'NA',
      Device: sessionStorage.getItem('device') || 'desktop',
      Device_Type: sessionStorage.getItem('deviceType') || 'web',
      Status: sessionStorage.getItem('status') || 'LoggedOut',
      Php_SessionID_Mod: sessionStorage.getItem('phpSessId') || '0',
    });
    if (handleJobApply) {
      const coverLetter = settings.coverLetter ? coverLetterId : 0;
      handleJobApply(
        jobInfo,
        coverLetter,
        false,
        true,
        () => {},
        ref,
        router.query
      );
    } else {
      console.error('applyjobhandler not defined');
    }
  };

  const performLogoutAction = () => {
    // window.alert('Please login before Apply');
    // setTimeout(() => {
    //   router.push('/');
    // }, 1000);
    setLoginOpen(true);
  };

  const onJobSave = (jobId: number) => {
    setSavingJob(true);
    dispatch(
      saveJob({
        jobId,
        unsave: !!jobInfo.saved,
        userId,
      })
    );
  };

  useEffect(() => {
    if (savingJob && jobInfo.saved) {
      setSaved(true);
      setSavingJob(false);
    }
  }, [jobInfo.saved]);

  useEffect(() => {
    const sendTrackingEvents = () => {
      const userId = sessionStorage.getItem('userId') || '';
      handleTracking('ViewJobDescription', {
        event_category: 'Job',
        Source: 'JobDescription',
        UserId: userId,
        Jobid: jobInfo.id,
        RecruiterId: jobInfo.recruiter?.recruiterId,
        Device: sessionStorage.getItem('device') || 'desktop',
        Origin: router.pathname,
        Status: sessionStorage.getItem('status') || 'LoggedOut',
        CategoryId: jobInfo.categoryId,
        Ref: (router.query.ref as string) || '',
        content_id: jobInfo.id,
        content_type: 'product',
      });
    };

    const timeoutId = setTimeout(sendTrackingEvents, 500);

    return () => {
      clearTimeout(timeoutId);
    };
  }, [
    jobInfo.categoryId,
    jobInfo.categoryName,
    jobInfo.id,
    jobInfo.jobPos,
    jobInfo.jobVersion,
    jobInfo.recruiterId,
    router.query.ref,
    jobInfo.title,
    router.pathname,
    jobInfo.showcase,
    jobInfo?.companyData?.companyName,
  ]);

  const saveJobForLogged = () => {
    deferTask(() => {
      if (!isLoggedIn) {
        performLogoutAction();
        setLoginRedirect('saveJobForLogged');
        return;
      }

      onJobSave(jobInfo.id);
    });
  };

  const onLoginSuccess = () => {
    if (isCSR()) {
      if (loginRedirect === 'openApply') {
        setLoginOpen(false);
      } else {
        window.location.reload();
      }
    }
  };

  useEffect(() => {
    if (loginRedirect === 'openApply' && isLoggedIn && !loginOpen && email) {
      openApply();
    }
  }, [loginRedirect, loginOpen, isLoggedIn, email]);

  const onJobFeedSave = () => {
    if (!isLoggedIn) {
      setLoginOpen(true);
    }
  };

  const handleUbaTracking = (section?: string) => {
    TrackEventUBA('jdPageClick', 'click', {
      ref: router.query.ref || '',
      pageName: 'Job Description Page',
      jobVersion: router.query.jobVersion || '',
      jobPos: router.query.jobPos || '',
      jobID: jobInfo.id,
      page: 'JD',
      sessionUsername: sessionStorage.getItem('userId') || userId || '',
      section: section || 'Apply',
    });
  };

  const openApply = async () => {
    // TrackEventUBA('jdPageClick', 'click', {
    //   ref: router.query.ref || '',
    //   pageName: 'Job Description Page',
    //   jobID: jobInfo.id,
    //   jobRef: getKeyFromPath('ref') || '',
    //   jobVersion: '',
    //   jobPos: router.query.jobPos || '',
    //   page: 'JD',
    //   sessionUsername: sessionStorage.getItem('userId') || userId || '',
    //   section: 'Apply',
    // });
    setIsApplying(true);
    const shouldKeepApplying = await applyOnJob({
      isLoggedIn,
      performLogoutAction,
      setLoginRedirect,
      setApplyJobDialogState,
      jobInfo,
      setOpenResumeBanner,
      router,
      userData,
      refInfo,
    });
    if (!shouldKeepApplying) {
      setIsApplying(false);
    }
  };

  const handleJobFollowup = (jobid: string) => {
    const jobId = jobid;
    deferTask(() => {
      handleTracking('ClickFollowUp', {
        event_category: 'Job',
        Origin: router.pathname,
        Source: 'JobDescription',
        CategoryId: jobInfo.categoryId,
        JobId: jobInfo.id,
        RecruiterId: jobInfo.recruiter?.recruiterId,
        UserId: sessionStorage.getItem('userId') || 'NA',
        Device: sessionStorage.getItem('device') || 'desktop',
        Device_Type: sessionStorage.getItem('deviceType') || 'web',
        Status: sessionStorage.getItem('status') || 'LoggedOut',
      });
      TrackEventUBA('jdPageClick', 'click', {
        ref: router.query.ref || '',
        pageName: 'Job Description Page',
        jobID: jobInfo.id,
        jobRef: getKeyFromPath('ref') || '',
        jobVersion: '',
        jobPos: router.query.jobPos || '',
        page: 'JD',
        section: 'Followup',
        sessionUsername: sessionStorage.getItem('userId') || '',
        membershipStatus: isPro ? 'Pro' : 'No Membership',
      });
      if (!isLoggedIn) {
        performLogoutAction();
        setLoginRedirect('handleJobFollowup');
        return;
      }

      if (!isPro) {
        const proLink = getProLink(
          'jd',
          jobInfo?.id?.toString(),
          proMembership?.followupBanner?.refCode,
          proMembership?.followupBanner?.refFeature
        );

        openUrl(proLink, '_self');
      }

      if (jobInfo?.applied) {
        (async () => {
          try {
            const followUp = await jobDetailService.doFollowUp({jobId});
            if (typeof followUp === 'boolean') {
              // await userService.updateFollowUp();
              setFollowedUp(followUp);
            }
          } catch (error: unknown) {
            console.log('🚀 ~ file: index.tsx:298 ~ error:', error);
          }
        })();
      }
    });
  };

  const redirectCallbackMap: any = {
    openApply,
    openInsightsDialog,
    handleJobFollowup,
  };

  const fetchSurveys = async () => {
    const surveys: SurveyType[] = await surveyService.getSurvey('JD');
    if (surveys?.length) {
      const videoJDSurvey = surveys.find(survey => survey?.type === 'VideoJD');
      if (videoJDSurvey) {
        setShowSurvey(true);
        handleTracking('jsViewVideoJDSurvey', {
          event_category: 'Video JD Survey',
          Origin: 'JobDetail',
          JobId: jobId,
          UserId: sessionStorage.getItem('userId') || 'NA',
          Device: sessionStorage.getItem('device') || 'desktop',
          Device_Type: sessionStorage.getItem('deviceType') || 'web',
        });
        setSurveyQuestions(videoJDSurvey?.questions);
        setCurrQuestion(videoJDSurvey?.questions[0]);
      }
    }
  };
  // parameter list should be updated with login pop up
  // useEffect(() => {
  //   if (loginOpen && loginRedirect === 'openApply') {
  //     TrackEventUBA('loginPopUpView', 'view', {
  //       ref: router.query.ref || '',
  //       pageName: 'Job Description Page',
  //       jobID: jobInfo.id,
  //       jobRef: getKeyFromPath('ref') || '',
  //       jobVersion: '',
  //       jobPos: router.query.jobPos || '',
  //       page: 'JD',
  //       sessionUsername: sessionStorage.getItem('userId') || '',
  //     });
  //   }
  // }, [loginOpen]);
  const isBranded = brandedJD === 1;
  useEffect(() => {
    if (loginOpen && isLoggedIn) {
      setLoginOpen(false);
      if (loginRedirect) {
        const redirectCallback = redirectCallbackMap[loginRedirect];
        if (redirectCallback) redirectCallback();
      }
    } else if (isLoggedIn) {
      dispatch(
        getMagicRank({
          jobId: jobId,
          headers: {},
        })
      );
    }

    if (isLoggedIn) {
      fetchSurveys();
    }
  }, [isLoggedIn]);

  useEffect(() => {
    if (jobInfo?.followUpStatus) {
      setFollowedUp(true);
    }
  }, [email, jobInfo?.id]);
  const [expanded, setExpanded] = useState(false);

  const toggleExpand = () => setExpanded(prev => !prev);
  const [ABDesc, setABDesc] = useState<string>(
    !isBranded || expanded
      ? jobInfo?.introText
      : jobInfo?.introText?.substr(0, 1200).trim()
  );
  const trackEvent = () => {
    TrackEventUBA('companyBannerClick', 'click', {
      ref: getKeyFromPath('ref') || '',
      pageName: 'Job Description Page',
      jobID: jobInfo.id ?? '',
      categoryID: page === 'category' ? jobInfo?.categoryId : undefined,
      tagID: page === 'tag' ? jobInfo?.categoryId : undefined,
      page: 'JD',
      sessionUsername: sessionStorage.getItem('userId') || '',
      companyName: jobInfo?.showcase?.showcaseName || '',
      companyID: jobInfo?.showcase?.showcaseCompanyId || '',
    });
  };
  useEffect(() => {
    if (jobInfo?.showcase) {
      TrackEventUBA('companyBannerView', 'view', {
        ref: getKeyFromPath('ref') || '',
        pageName: 'Job Description Page',
        page: 'JD',
        sessionUsername: sessionStorage.getItem('userId') || '',
        companyName: jobInfo?.showcase?.showcaseName || '',
        companyID: jobInfo?.showcase?.showcaseCompanyId || '',
      });
    }
  }, [jobInfo?.showcase]);

  const getJobOverViewCard = (display: {xxs: string; md: string}) => {
    return (
      <Card
        sx={{
          borderRadius: 4,
          py: {xxs: isBranded ? 1 : 2, md: 2},
          px: {xxs: isBranded ? 1 : 2, md: 2},
          mb: isBranded ? 1.25 : 2,
          display: display,
          boxShadow: {xxs: isBranded ? 'none' : 'auto', md: 'auto'},
          border: {
            xxs: isBranded ? '1px solid rgba(126, 126, 126, 0.20)' : 'none',
            md: 'none',
          },
          mt: {xxs: isBranded ? 2 : 0, md: 0},
        }}
      >
        <JobOverviewCard
          actionUrl={
            !jobInfo?.confidential
              ? getOldLink(
                  `/r/${jobInfo?.recruiter?.recruiterId}-${kebabCase(
                    jobInfo?.recruiter?.recruiterName.replace(/&/g, '-and-')
                  )}`
                )
              : '#'
          }
          recruiterImgUrl={
            !jobInfo?.confidential
              ? jobInfo?.recruiter?.profilePicUrl
              : `${getOldLink('/resources/img/user.jpg')}`
          }
          lastActive={
            jobInfo?.recruiter?.lastActive
              ? moment(jobInfo.recruiter.lastActive).isValid()
                ? moment(jobInfo.recruiter.lastActive).format('DD MMMM YYYY')
                : jobInfo.recruiter.lastActive
              : ''
          }
          confidential={jobInfo?.confidential === 1}
          jobId={jobInfo?.id}
          jobViews={jobInfo?.hits}
          applications={jobInfo?.applicationCount ?? jobInfo?.applyCount}
          recruiterActions={
            jobInfo?.recruiterActionCount ??
            jobInfo?.recruiter?.recruiterActions
          }
          setOpenConfJobDialog={setOpenConfJobDialog}
          enableMagicRank={isLoggedIn ? 1 : 0}
          magicSortRank={jobInfo.magicRank}
          category={jobCategory}
          position={
            !jobInfo?.confidential
              ? `${jobInfo?.recruiter?.designation} at ${jobInfo?.companyData?.companyName}`
              : ''
          }
          recruiterName={
            !jobInfo?.confidential
              ? jobInfo?.recruiter?.recruiterName
              : 'Verified Recruiter'
          }
          variant={VersionVariants.VERSION_TWO}
          proValid={isPro}
          openInsightsDialog={openInsightsDialog}
          showRecommended={isShortlisted}
          postedOn={moment(jobInfo?.createdTime).toISOString()}
          showReadMore={isBranded}
          isExpanded={jobOverviewExpanded}
          onToggle={toggleJobOverview}
          isProLoading={isProLoading}
        />
      </Card>
    );
  };

  const getApplyBottom = (bottom?: boolean) => {
    return (
      <Grid item xxs={12}>
        <Grid
          container
          mb={bottom ? 0 : 2}
          alignItems={'end'}
          rowSpacing={1.5}
          columnSpacing={2}
        >
          <Grid item xxs={12} md={'auto'}>
            <Button
              sx={{
                width: {xxs: '100%', md: '200px'},
                background: '#333333',
                py: bottom ? 1.5 : 1,
              }}
              variant="contained"
              size="large"
              disabled={jobInfo?.applied ? true : isApplying}
              onClick={
                jobInfo?.applied
                  ? () => {}
                  : () => {
                      deferTask(() => {
                        handleUbaTracking();
                        openApply();
                      });
                    }
              }
            >
              {jobInfo?.applied ? (
                'Applied'
              ) : isApplying ? (
                <Loader sx={{color: '#fff'}} size={24} />
              ) : (
                'Apply'
              )}
            </Button>
            <div ref={staticTarget}></div>
          </Grid>
          <Grid item xxs={12} md={'auto'} display={{xxs: 'none', md: 'block'}}>
            <Button
              sx={{
                width: {xxs: '100%', md: '200px'},
                borderColor: 'primary',
                py: bottom ? 1.5 : 1,
              }}
              variant={!jobInfo.saved ? 'outlined' : 'contained'}
              size="large"
              color="primary"
              onClick={!jobInfo.saved ? saveJobForLogged : () => {}}
            >
              {jobInfo.saved ? 'Saved' : 'Save'}
            </Button>
          </Grid>

          <Grid item xxs={12} display={{xxs: 'flex', md: 'none'}} columnGap={2}>
            <Grid item xxs={12} md={'auto'}>
              <Button
                sx={{
                  width: {xxs: '100%', md: '200px'},
                  borderColor: 'primary',
                }}
                variant={!jobInfo.saved ? 'outlined' : 'contained'}
                size="large"
                color="primary"
                onClick={!jobInfo.saved ? saveJobForLogged : () => {}}
              >
                {jobInfo.saved ? 'Saved' : 'Save'}
              </Button>
            </Grid>

            <Grid
              item
              xxs={12}
              md={'auto'}
              display={{xxs: 'block', md: 'none'}}
            >
              <Button
                sx={{
                  width: {xxs: '100%', md: '200px'},
                  borderColor: 'primary',
                  display: 'flex',
                  gap: 0.5,
                }}
                variant={'outlined'}
                size="large"
                color="primary"
                onClick={openInsightsDialog}
              >
                {!isPro && (
                  <ProChip
                    key={'Pro0'}
                    bgColor="linear-gradient(180deg, #FFB743 0%, #F99914 100%)"
                  />
                )}
                Insights
              </Button>
            </Grid>
          </Grid>
          {!isProLoading && (
            <Grid
              item
              xxs={12}
              md
              display={{xxs: 'none', md: 'flex'}}
              justifyContent={{
                xxs: 'flex-start',
                md: isBranded ? 'flex-start' : 'flex-end',
              }}
              sx={{alignItems: 'center'}}
              gap={1}
              pb={0.5}
            >
              {!isPro ? (
                <Tooltip
                  arrow
                  title={
                    <Box mb={0.6}>
                      <Typography
                        component={'p'}
                        fontSize={theme.typography.pxToRem(12)}
                        fontWeight={theme.typography.fontWeightMedium}
                        color={'secondary.main'}
                      >
                        Now you can also <b>FOLLOW UP</b> on any applied
                        application where you think you are good fit with PRO.
                      </Typography>
                      <Button
                        sx={{
                          background: theme.palette.pro.main,
                          py: 0.5,
                          px: 1.5,
                          mt: bottom ? 0 : 1,
                          fontSize: theme.typography.pxToRem(12),
                          '@media (width: 320px)': {
                            fontSize: theme.typography.pxToRem(10),
                          },
                        }}
                        variant="contained"
                        size="small"
                        onClick={() => {
                          handleJobFollowup(jobInfo?.id.toString());
                        }}
                      >
                        Upgrade to PRO
                      </Button>
                    </Box>
                  }
                >
                  <Link
                    onClick={() => {
                      handleJobFollowup(jobInfo?.id.toString());
                    }}
                    sx={{
                      mt: bottom ? -5.5 : 0,
                      textDecoration: 'none',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      ':hover': {
                        textTransform: '',
                      },
                    }}
                  >
                    <Typography
                      color={'primary.main'}
                      component={'p'}
                      sx={{cursor: 'pointer'}}
                      variant="subtitle1"
                      mr={0.5}
                    >
                      Follow Up
                    </Typography>
                    {isPro != null && (
                      <ProChip
                        key={'Pro1'}
                        bgColor="linear-gradient(180deg, #FFB743 0%, #F99914 100%)"
                      />
                    )}
                  </Link>
                </Tooltip>
              ) : (
                <>
                  {followup ? (
                    <Box sx={{mt: bottom ? -5.5 : 0}}>
                      <Image src={ThumbUp} width={20} height={20} alt="" />
                      <Typography
                        color="primary.main"
                        sx={{cursor: 'pointer'}}
                        variant="subtitle1"
                      >
                        {'Followed Up'}
                      </Typography>
                    </Box>
                  ) : (
                    <Tooltip
                      arrow
                      placement="bottom-end"
                      PopperProps={{
                        modifiers: [
                          {
                            name: 'offset',
                            options: {offset: [0, bottom ? 16 : 0]},
                          },
                        ],
                      }}
                      title={
                        <>
                          <Typography
                            component={'p'}
                            fontSize={theme.typography.pxToRem(12)}
                            fontWeight={theme.typography.fontWeightMedium}
                            color={'secondary.main'}
                          >
                            {jobInfo?.applied
                              ? 'Follow Up on your Job Application'
                              : 'Apply for the job before following Up'}
                          </Typography>
                        </>
                      }
                      sx={{
                        display: 'flex',
                        justifyContent: 'flex-end',
                      }}
                    >
                      <Box
                        display={'flex'}
                        justifyContent={'flex-end'}
                        alignItems={'center'}
                        width={'fit-content'}
                        ml="auto"
                      >
                        <Typography
                          // color="primary.main"
                          component={'p'}
                          color={
                            jobInfo?.applied && isPro
                              ? 'primary.main'
                              : !isLoggedIn
                              ? 'primary.main'
                              : 'gray.dark'
                          }
                          sx={{
                            cursor: 'pointer',
                            mt: bottom ? -5.5 : 0,
                            width: '100%',
                            textAlign: 'right',
                          }}
                          onClick={() => {
                            handleJobFollowup(jobInfo?.id.toString());
                          }}
                          variant="subtitle1"
                        >
                          {'Follow Up'}
                        </Typography>
                      </Box>
                    </Tooltip>
                  )}
                </>
              )}
            </Grid>
          )}
        </Grid>
      </Grid>
    );
  };

  const getAwardsCard = () => {
    return (
      <>
        <Wrapper
          heading={
            <Box
              display="flex"
              alignItems="center"
              mb={0}
              paddingLeft={'12px'}
              paddingTop={'17px'}
              gap={0.75}
            >
              <Typography variant="subtitle2">
                {' '}
                {brandedData?.awardsRecognitions?.awardsHeading ||
                  'Awards & Recognition'}
              </Typography>
            </Box>
          }
          component={
            <CompanyAwards
              awards={brandedData?.awardsRecognitions?.data?.awardsList || []}
              templateInfo={brandedData?.templateInfo}
              jobInfo={jobInfo}
              jdQueryParams={jdQueryParams}
            />
          }
          isAppIimjobs={isAppIimjobs}
        />
        {brandedData?.sourceAttribution?.visibility && (
          <Typography
            mb={1.25}
            fontSize={10}
            fontWeight={400}
            color={'#6E7287'}
          >
            {brandedData?.sourceAttribution?.sourceAttributionText}
          </Typography>
        )}
      </>
    );
  };

  const getVerifiedBenefitsCard = () => {
    return (
      <Wrapper
        heading={
          <Box
            display="flex"
            alignItems="center"
            paddingLeft={'12px'}
            paddingTop={'17px'}
            gap={0.75}
          >
            <Image src={VerifiedIcon} alt="verified" height={18} width={18} />
            <Typography variant="subtitle2">
              {brandedData?.benefits?.benefitsHeading ||
                'Company Verified Benefits'}
            </Typography>
          </Box>
        }
        component={
          <EmployerBenefits
            benefits={brandedData?.benefits?.data?.benefitsList || []}
            isAppIimjobs={isAppIimjobs}
            templateInfo={brandedData?.templateInfo || {}}
            isExpanded={brandedBenefitsExpanded}
            onToggle={toggleBrandedBenefits}
            heading={
              brandedData?.benefits?.benefitsHeading ||
              'Company Verified Benefits'
            }
            jobInfo={jobInfo}
            jdQueryParams={jdQueryParams}
          />
        }
        isAppIimjobs={isAppIimjobs}
      />
    );
  };

  const getCompanyReview = () => {
    return (
      brandedData?.reviews?.data && (
        <Wrapper
          heading={
            <Box
              display="flex"
              alignItems="center"
              px={'12px'}
              paddingTop={'17px'}
              justifyContent={'space-between'}
              gap={0.75}
            >
              <Box display={'flex'} alignItems="center" gap={0.75}>
                <Image src={ThreeStar} alt="verified" height={22} width={22} />
                <Typography variant="subtitle2">Reviews </Typography>
              </Box>
              <Typography
                component={'a'}
                target="_blank"
                rel="noopener noreferrer"
                href={
                  brandedData?.reviews?.data?.reviewData[0]?.reviewLink || '#'
                }
                onClick={() => {
                  TrackEventUBA('jdPageClick', 'click', {
                    ref: router.query.ref || '',
                    pageName: 'Job Description Page',
                    jobID: jobInfo?.id,
                    jobVersion: '',
                    jobRef: getKeyFromPath('ref') || '',
                    jobPos: router.query.jobPos || '',
                    page: 'JD',
                    section: 'Reviews',
                    isBranded: isBranded ? 'Yes' : 'No',
                    sessionUsername: sessionStorage.getItem('userId') || '',
                    typeClick: 'Reviews-SeeAllReviews',
                    companyID: jobInfo?.companyData?.companyId,
                    centralCompanyID: jobInfo?.recruiter?.centralizedCompanyId,
                    companyName: jobInfo?.companyData?.companyName,
                    templateID: brandedData?.templateInfo?.templateNo,
                  });
                }}
                sx={{
                  fontSize: 12,
                  fontWeight: 500,
                  color: '#49966E',
                  textDecoration: 'none',
                }}
              >
                {`All ${brandedData?.reviews?.data?.reviewData[0]?.reviewsCount} Reviews`}
              </Typography>
            </Box>
          }
          component={
            <CompanyReview
              data={brandedData?.reviews?.data}
              templateInfo={brandedData?.templateInfo}
              jobInfo={jobInfo}
              jdQueryParams={jdQueryParams}
              isAppIimjobs={isAppIimjobs}
            />
          }
          isAppIimjobs={isAppIimjobs}
        />
      )
    );
  };

  const getCompanyJobs = () => {
    return (
      (similarJobs?.length || 0) > 0 && (
        <Wrapper
          heading={
            <Box
              display="flex"
              alignItems="center"
              paddingLeft={'12px'}
              paddingTop={'17px'}
              gap={0.75}
            >
              <Typography variant="subtitle2">
                {`Discover similar roles at ${brandedData?.aboutCompany?.companyName}`}
              </Typography>
            </Box>
          }
          component={
            <CompanyJobs
              jobs={similarJobs || []}
              companyName={brandedData?.aboutCompany?.companyName || ''}
              isExpanded={companyJobsExpanded}
              onToggle={toggleCompanyJobs}
              templateInfo={brandedData?.templateInfo}
              jobInfo={jobInfo}
              jdQueryParams={jdQueryParams}
              isAppIimjobs={isAppIimjobs}
            />
          }
          isAppIimjobs={isAppIimjobs}
        />
      )
    );
  };
  const getClients = () => {
    return (
      <Wrapper
        heading={
          <Box
            display="flex"
            alignItems="center"
            paddingLeft={'12px'}
            paddingTop={'15px'}
            gap={0.75}
          >
            <Typography variant="subtitle2">
              {brandedData?.clients?.heading}
            </Typography>
          </Box>
        }
        component={
          <Clients
            Clients={brandedData?.clients?.data || []}
            templateInfo={brandedData?.templateInfo}
            jobInfo={jobInfo}
            jdQueryParams={jdQueryParams}
            isAppIimjobs={isAppIimjobs}
          />
        }
        isAppIimjobs={isAppIimjobs}
      />
    );
  };

  const getInsights = () => {
    return (
      <>
        <Wrapper
          heading={
            <Box
              display="flex"
              alignItems="center"
              paddingLeft={'12px'}
              paddingTop={'15px'}
              gap={0.75}
            >
              <Typography variant="subtitle2">
                {brandedData?.hiringTrends?.heading}
              </Typography>
            </Box>
          }
          component={
            <CompanyInsights
              insights={brandedData?.hiringTrends?.insights}
              templateInfo={brandedData?.templateInfo}
              jobInfo={jobInfo}
              jdQueryParams={jdQueryParams}
              isAppIimjobs={isAppIimjobs}
            />
          }
          isAppIimjobs={isAppIimjobs}
        />
        <Typography mb={1.25} fontSize={10} fontWeight={400} color={'#6E7287'}>
          {brandedData?.sourceAttribution?.sourceAttributionText}
        </Typography>
      </>
    );
  };

  const getHighLights = () => {
    return (
      <Wrapper
        heading={
          <Box
            display="flex"
            alignItems="center"
            paddingLeft={'12px'}
            paddingTop={'17px'}
            gap={0.75}
          >
            <Typography variant="subtitle2">
              {brandedData?.keyHighlights?.keyHighlightsHeading ||
                `Key Highlights at ${brandedData?.aboutCompany?.companyName}`}{' '}
            </Typography>
          </Box>
        }
        component={
          <CompanyHighLights
            highLights={
              brandedData?.keyHighlights?.data?.keyHighlightsList || []
            }
            heading={
              brandedData?.keyHighlights?.keyHighlightsHeading ||
              `Key Highlights at ${brandedData?.aboutCompany?.companyName}`
            }
            isAppIimjobs={isAppIimjobs}
            templateInfo={brandedData?.templateInfo}
            isExpanded={companyHighlightsExpanded}
            onToggle={toggleCompanyHighlights}
            jobInfo={jobInfo}
            jdQueryParams={jdQueryParams}
          />
        }
        isAppIimjobs={isAppIimjobs}
      />
    );
  };

  const isSearchEnabled = useSelector(
    (state: AppState) => state.app.layout.searchOverlay,
    shallowEqual
  );
  const jdApply = useSelector(
    (state: AppState) => state.app.jobdetail.apply,
    shallowEqual
  );
  useEffect(() => {
    if (jdApply && !jobInfo?.applied && email) {
      openApply();
    }
  }, [jdApply, jobInfo?.applied, email]);

  // useEffect(() => {
  //   if (resumeUpdated && email && resumeBannerSuccess) {
  //     setOpenResumeBanner(false);
  //     openApply();
  //   }
  // }, [resumeUpdated, email, resumeBannerSuccess]);

  useEffect(() => {
    try {
      if (jobInfo?.id && jobInfo?.categoryId) {
        dispatch(
          fetchSimilarJobs({
            userId,
            exp: getExperienceIndex(jobInfo?.min) || undefined,
            id: jobInfo?.id,
            cat: jobInfo?.categoryId,
            tags: jobInfo?.tags?.map((x: {id: number}) => x.id?.toString()),
          })
        );
      }
    } catch (error) {
      console.log('🚀 ~ file: [jobslug].tsx:179 ~ store=> ~ error:', error);
    }
  }, [jobInfo?.id, jobInfo?.categoryId]);

  const additionalInfo: any[] = useMemo(() => {
    const _additionalInfo: any[] = [];
    jobInfoKeyElements.forEach((key: {value: string; label: string}) => {
      const {label, value} = key;
      if (jobInfo[label]) {
        _additionalInfo.push({
          label: value,
          // value,
          icon: additionalInfoIconMap[label],
        });
      }
    });
    return _additionalInfo;
  }, []);

  useEffect(() => {
    jobDetailService.markJobViewed(jobId);
  }, []);

  const [showFloatingButton, setShowFloatingButton] = useState(true);
  const staticTarget = useRef<HTMLDivElement>(null);

  const jobDescriptionRef = useRef<HTMLDivElement>(null);
  const companyHighlightsRef = useRef<HTMLDivElement>(null);
  const clientRef = useRef<HTMLDivElement>(null);
  const InsightsRef = useRef<HTMLDivElement>(null);

  const companyAwardsRef = useRef<HTMLDivElement>(null);
  const companyBenefitsRef = useRef<HTMLDivElement>(null);
  const companyReviewsRef = useRef<HTMLDivElement>(null);
  const aboutCompanyRef = useRef<HTMLDivElement>(null);
  const companyJobsRef = useRef<HTMLDivElement>(null);
  const salaryString = formatSalary(
    jobInfo?.minSal,
    jobInfo?.maxSal,
    jobInfo?.hideSal
  );

  const randomColor = useMemo(
    () => getRandomColor(jobInfo?.id),
    [jobInfo?.companyData]
  );
  const navigationSections = [
    {
      id: 'job-description',
      label: 'Job Detail',
      ref: jobDescriptionRef,
      tag: 'JobDetail',
    },
  ];

  if (isBranded && brandedData?.aboutCompany?.visibility) {
    navigationSections.push({
      id: 'about-company',
      label: 'About The Company',
      ref: aboutCompanyRef,
      tag: 'AboutCompany',
    });
  }

  if (isBranded && brandedData?.benefits?.visibility) {
    navigationSections.push({
      id: 'company-benefits',
      label: 'Benefits',
      ref: companyBenefitsRef,
      tag: 'Benefits',
    });
  }

  if (isBranded && brandedData?.reviews?.visibility) {
    navigationSections.push({
      id: 'review-company',
      label: 'Reviews',
      ref: companyReviewsRef,
      tag: 'Reviews',
    });
  }

  const trigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: 700,
  });
  let isEventFired = false;
  const [triggerState, setTriggerState] = useState(false);

  const sendEvent = (
    eventCatogary: string,
    eventName: string,
    action: string
  ) => {
    handleTracking(`${eventName}_${action}`, {
      event_category: `${eventCatogary}`,
      Origin: page,
      UserId: sessionStorage.getItem('userId') || 'NA',
      Device: sessionStorage.getItem('device') || 'desktop',
      Device_Type: sessionStorage.getItem('deviceType') || 'web',
      Status: sessionStorage.getItem('status') || 'LoggedOut',
      Php_SessionID_Mod: sessionStorage.getItem('phpSessId') || '0',
    });
  };
  useEffect(() => {
    if (trigger) {
      setTriggerState(true);
    }
  }, [trigger]);

  useEffect(() => {
    const handleScroll = debounce(() => {
      if (!staticTarget.current) return;

      const staticButtonTop = staticTarget.current.getBoundingClientRect().top;

      const sectionRefs = [
        companyJobsRef,
        companyHighlightsRef,
        companyAwardsRef,
        companyBenefitsRef,
        companyReviewsRef,
        clientRef,
        InsightsRef,
      ];

      const inCompanySection = sectionRefs.some(ref => {
        if (!ref.current) return false;
        const rect = ref.current.getBoundingClientRect();
        return rect.top < window.innerHeight && rect.bottom > 0;
      });

      if (
        !jobInfo?.applied &&
        (staticButtonTop > window.innerHeight || inCompanySection) &&
        !isEventFired &&
        triggerState
      ) {
        setShowFloatingButton(true);
        sendEvent('Floating_Apply_Button', 'Floating_Apply_Btn', 'View');
        isEventFired = true;
      } else {
        setShowFloatingButton(
          staticButtonTop - 100 > window.innerHeight || inCompanySection
        );
      }
    }, 500);
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [triggerState]);

  useEffect(() => {
    sendEvent('App_Promotion', 'DownloadAppQR1Desktop', 'View');
  }, []);
  const isAboveMD = useIsLargeDevice('md');
  const ref = router.query.ref || '';
  const {device} = useSelector(
    (state: AppState) => state.app.layout,
    shallowEqual
  );
  const isLargeDevice = device == 'desktop';

  const showLinkedInBanner = !isAboveMD && (ref == 'linkedin' || ref == 'ln');

  const trackJobfeedInterest = async (email: string, sessionId: string) => {
    try {
      await userService.trackJobfeedInterest({
        email,
        jobId,
        sessionId,
      });
    } catch (error) {
      console.error('Failed to track jobfeed interest:', error);
    }
  };

  const [
    showLinkedInEmailCaptureDialogue,
    setShowLinkedInEmailCaptureDialogue,
  ] = useState(false);
  const hasUserInteractedRef = useRef(false);

  useEffect(() => {
    const shouldEnableBanner =
      (ref === 'linkedin' || ref === 'ln') && !isLoggedIn && !isLargeDevice;

    if (!shouldEnableBanner) return;

    const INACTIVITY_MS = 3000;
    let timeoutId: ReturnType<typeof setTimeout> | null = null;

    const handleUserActivity = () => {
      hasUserInteractedRef.current = true;

      if (timeoutId) {
        clearTimeout(timeoutId);
        timeoutId = null;
      }

      window.removeEventListener('scroll', handleUserActivity);
      window.removeEventListener('click', handleUserActivity);
    };

    timeoutId = setTimeout(async () => {
      if (!hasUserInteractedRef.current) {
        const cookies = cookie.parse(document?.cookie);
        const popupShown = cookies['linkedin_email_capture_shown'] === '1';
        const sessionId = cookies['linkedin_email_capture_sessionId'];
        if (popupShown) {
          if (sessionId) {
            // Don't show pop-up
            await trackJobfeedInterest('', sessionId);
          }
        } else {
          setShowLinkedInEmailCaptureDialogue(true);
          const expiryDate = new Date();
          expiryDate.setTime(expiryDate.getTime() + 24 * 60 * 60 * 1000);
          setCookie('linkedin_email_capture_shown', '1', {
            path: '/',
            expires: expiryDate,
          });
        }
      }
      window.removeEventListener('scroll', handleUserActivity);
      window.removeEventListener('click', handleUserActivity);
    }, INACTIVITY_MS);

    window.addEventListener('scroll', handleUserActivity, {passive: true});
    window.addEventListener('click', handleUserActivity);

    return () => {
      if (timeoutId) clearTimeout(timeoutId);
      window.removeEventListener('scroll', handleUserActivity);
      window.removeEventListener('click', handleUserActivity);
    };
  }, [router.query.ref, isLoggedIn, isLargeDevice]);

  return (
    <>
      {showLinkedInEmailCaptureDialogue && (
        <LinkedInEmailCaptureComponent
          jobId={jobId}
          trackJobfeedInterest={trackJobfeedInterest}
        />
      )}
      {jobInfo && jobInfo?.id && <JobPostingJsonLd jobInfo={jobInfo} />}
      {isBranded && (
        <>
          {jobInfo && jobInfo?.id && brandedData?.banner?.visibility ? (
            <JDBrandingBanner
              bannerUrl={
                brandedData?.banner?.preferenceKey == 'bannerVideo'
                  ? brandedData?.banner?.bannerVideo?.path || ''
                  : brandedData?.banner?.bannerImage?.path || ''
              }
              isAppIimjobs={isAppIimjobs}
              templateInfo={brandedData?.templateInfo}
              thumbnail={brandedData?.banner?.bannerVideo?.thumbnailPath || ''}
              jobInfo={jobInfo}
              jdQueryParams={jdQueryParams}
            />
          ) : (
            <Skeleton
              variant="rectangular"
              sx={{
                aspectRatio: '24/5',
                minHeight: {xxs: 82, md: 213, lg: 266, xl: 300},
                mb: {xxs: -2, md: -4.5},
                mt: -2,
                ml: {xxs: -2, md: 0},
                width: {xxs: 'calc(100% + 32px)', md: '100%'},
                borderRadius: 0,
              }}
            />
          )}
        </>
      )}
      <Grid container spacing={3} overflow={isBranded ? 'hidden' : ''}>
        <Grid item xxs={12} md={8.5} lg={8.8} zIndex={isBranded ? 10 : 0}>
          <InjectSearchOverlay isSearchEnabled={isSearchEnabled} />

          {!!jobInfo?.applied && jobInfo?.recruiterActionText && !isBranded && (
            <>
              <JobStatusBar
                setShowProMembershipPrompt={setShowProMembershipPrompt}
                isPro={isPro}
                isProLoading={isProLoading}
                isStatusChangeCohortUser={isStatusChangeCohortUser}
              />
              {showProMembershipPrompt && (
                <ProMembershipPlanPopUp
                  open={showProMembershipPrompt}
                  handleClose={() => {
                    setShowProMembershipPrompt(false);
                    handleTracking('jsCrossProPopUp', {
                      event_category: 'UpgradeToPro',
                      UserId: sessionStorage.getItem('userId') || 'NA',
                      Device: sessionStorage.getItem('device') || 'desktop',
                      Device_Type:
                        sessionStorage.getItem('deviceType') || 'web',
                      Status: sessionStorage.getItem('status') || 'LoggedOut',
                    });
                  }}
                />
              )}
            </>
          )}

          {jobInfo &&
            jobInfo?.id &&
            !isBranded &&
            getJobOverViewCard({xxs: 'flex', md: 'none'})}
          {jobInfo && jobInfo?.id && (
            <JobDetailCard
              noShadow
              title={jobInfo?.title?.split('(')[0]?.trim()}
              experiance={`${jobInfo?.min} - ${jobInfo?.max} yrs`}
              companyName={jobInfo?.companyData?.companyName}
              date={moment(jobInfo?.createdTime).toDate()}
              location={getLocationString(jobInfo?.locations)}
              variant={VersionVariants.VERSION_TWO}
              jobData={
                jobInfo
                  ? {
                      ...jobInfo,
                    }
                  : jobInfo
              }
              isDetailCard={true}
              // onJobClick={() => onJobClick(job)}
              additionalInfo={additionalInfo}
              isPremiumJob={!!jobInfo.premium}
              isSaved={!!jobInfo.saved}
              ubaTracking={handleUbaTracking}
              staticTarget={staticTarget}
              active={jobInfo?.active}
              saveJobForLogged={saveJobForLogged}
              openApply={openApply}
              isApplied={!!jobInfo.applied}
              isConsultant={
                brandedData?.sourceAttribution?.visibility ? true : false
              }
              // onSaveClick={onJobSave}
              companyImgUrl={
                jobInfo?.recruiter?.centralizedCompanyId &&
                !jobInfo?.confidential
                  ? `${process.env.NEXT_PUBLIC_S3_COMPANY_LOGO_BUCKET}${jobInfo?.recruiter?.centralizedCompanyId}.webp`
                  : ''
              }
              fallbackCompanyUrl={
                jobInfo?.recruiter?.centralizedCompanyId &&
                !jobInfo?.confidential
                  ? `${process.env.NEXT_PUBLIC_S3_COMPANY_LOGO_BUCKET}${jobInfo?.recruiter?.centralizedCompanyId}.webp`
                  : ''
              }
              onUbaClick={() => trackEvent()}
              category={jobCategory}
              careerCompanyName={jobInfo?.careerCompanyName}
              brandedJD={isBranded}
              isApplying={isApplying}
              isLargeDevice={isLargeDevice}
              sx={{
                borderRadius: 4,
                mt: {xxs: isBranded ? 0.5 : 0, md: 0},
                borderBottomLeftRadius: {
                  xxs: isBranded ? 0 : '16px',
                  md: '16px',
                },
                borderBottomRightRadius: {
                  xxs: isBranded ? 0 : '16px',
                  md: '16px',
                },
                mb: isBranded
                  ? {xxs: 0, md: jobInfo?.tags?.length > 0 ? 0 : 1.5}
                  : 0,
                pb: brandedData?.sourceAttribution?.visibility
                  ? {xxs: 0.5, md: 0}
                  : 0,
              }}
            />
          )}

          {!!jobInfo?.applied && jobInfo?.recruiterActionText && isBranded && (
            <Box
              mt={{xxs: isStatusChangeCohortUser ? 1 : 0, md: 0.5}}
              mb={{xxs: isStatusChangeCohortUser ? 0 : -1, md: 0}}
              sx={{
                background: {
                  xxs: isStatusChangeCohortUser ? 'inherit' : 'white',
                  md: 'transparent',
                },
              }}
            >
              <JobStatusBar
                setShowProMembershipPrompt={setShowProMembershipPrompt}
                isPro={isPro}
                isProLoading={isProLoading}
                isStatusChangeCohortUser={isStatusChangeCohortUser}
              />
              {showProMembershipPrompt && (
                <ProMembershipPlanPopUp
                  open={showProMembershipPrompt}
                  handleClose={() => {
                    setShowProMembershipPrompt(false);
                    handleTracking('jsCrossProPopUp', {
                      event_category: 'UpgradeToPro',
                      UserId: sessionStorage.getItem('userId') || 'NA',
                      Device: sessionStorage.getItem('device') || 'desktop',
                      Device_Type:
                        sessionStorage.getItem('deviceType') || 'web',
                      Status: sessionStorage.getItem('status') || 'LoggedOut',
                    });
                  }}
                />
              )}
            </Box>
          )}

          {/* Sticky Navigation */}
          {jobInfo && jobInfo?.id && isBranded && device != 'desktop' && (
            <StickyJobNavigation
              sections={navigationSections}
              onTabClick={sectionId => {
                console.log('Navigated to section:', sectionId);
              }}
              templateInfo={brandedData?.templateInfo}
              jobInfo={jobInfo}
            />
          )}

          <>
            {page === JOBDETAIL && isSmall && !showLinkedInBanner && (
              <FloatingApplyButton
                theme={theme}
                disabled={jobInfo?.applied ? true : false}
                onApply={
                  jobInfo?.applied
                    ? () => {}
                    : () => {
                        handleUbaTracking('Apply_Sticky');
                        openApply();
                      }
                }
                show={showFloatingButton}
                style={{
                  position: 'fixed',
                  width: '100%',
                  paddingLeft: theme.spacing(1.875),
                  paddingRight: theme.spacing(1.875),
                  bottom: '25px',
                  zIndex: 12,
                }}
                isPro={isPro}
                isProLoading={isProLoading}
                openInsightsDialog={openInsightsDialog}
                loading={isApplying}
              />
            )}
            {jobInfo && jobInfo?.id && jobInfo?.active ? (
              <>
                <Box>
                  <Card
                    ref={jobDescriptionRef}
                    sx={{
                      borderRadius: isBranded && isSmall ? 0 : 4,
                      borderBottomLeftRadius: 16,
                      borderBottomRightRadius: 16,
                      pl: 2,
                      pr: {xxs: 2, md: 2},
                      py: {xxs: 2, md: 3},
                      mt: isBranded && isSmall ? 0 : isBranded ? 1.5 : 2,
                    }}
                  >
                    <Grid container rowSpacing={2}>
                      {jobInfo?.confidential === 1 && (
                        <Box
                          sx={{
                            background:
                              'linear-gradient(157deg, #E7EFE7 0%, #E7EFE7 30%, #EEF4F3 65%, #F3F7FA 100%)',
                            height: {xxs: '67px', md: '58px'},
                            width: {xxs: '110%', md: '106%'},
                            mt: {xxs: '0px', md: '-8px'},
                            mx: '-14px',
                            borderRadius: '12px 12px 16px 16px',
                            display: 'flex',
                            position: 'relative',
                            p: 1,
                          }}
                        >
                          <Image
                            className="confidential_icon"
                            src={AIPixel}
                            alt={'Confidential icon'}
                            width={16}
                            height={20}
                            style={{
                              paddingTop: '6px',
                              objectFit: 'cover',
                            }}
                          />
                          <Box
                            sx={{
                              display: 'flex',
                              flexDirection: 'column',
                              py: 'auto',
                              px: '4px',
                              justifyContent: 'center',
                              gap: '3px',
                            }}
                          >
                            <Typography
                              sx={{
                                background:
                                  'linear-gradient(90deg, #225448 0%, #7E9F67 100%)',
                                WebkitBackgroundClip: 'text',
                                WebkitTextFillColor: 'transparent',
                                backgroundClip: 'text',
                                fontWeight: '500',
                                fontSize: {xxs: '11px', md: '12px'},
                                lineHeight: {xxs: '13px', md: '16px'},
                              }}
                            >
                              Confidential Job Posting
                            </Typography>
                            <Typography
                              sx={{
                                fontSize: '10px',
                                fontWeight: {xxs: '400', md: '500'},
                                lineHeight: {xxs: '13px', md: '16px'},
                              }}
                            >
                              This role is from a verified company that prefers
                              not to disclose its name at this stage.{' '}
                              <span
                                style={{
                                  color: '#49966E',
                                  cursor: 'pointer',
                                }}
                                onClick={() => {
                                  setOpenConfJobDialog(true);
                                }}
                              >
                                Learn More
                              </span>
                            </Typography>
                          </Box>
                          <Image
                            className="confidential_verified_tag"
                            src={ConfVerified}
                            alt={'confidential_verified_tag'}
                            width={136}
                            height={isSmall ? 17 : 21}
                            style={{
                              position: 'absolute',
                              right: isSmall ? '-1px' : '9px',
                              top: '2px',
                            }}
                            objectFit="cover"
                            quality={50}
                          />
                        </Box>
                      )}
                      <Grid item xxs={12}>
                        {jobInfo.videoUrl ? (
                          <Box
                            width={'100%'}
                            height={{xxs: 144, xs: 235, md: 374, lg: 590}}
                            borderRadius={4}
                            overflow={'hidden'}
                            mb={3}
                          >
                            <ReactPlayer
                              style={{}}
                              width="100%"
                              height="100%"
                              url={jobInfo.videoUrl}
                            />
                          </Box>
                        ) : (
                          ''
                        )}
                        <DialogWithBottomSheet
                          title={
                            <Typography
                              fontSize={{xxs: '14px', md: '16px'}}
                              fontWeight={500}
                            >
                              Understanding Confidential Job Postings
                            </Typography>
                          }
                          subTitle=""
                          open={openConfJobDialog}
                          sx={{
                            margin: 'auto',
                            '& .MuiDialog-paper': {
                              minWidth: {
                                md: '500px',
                              },
                              maxWidth: {
                                md: '700px',
                              },
                              width: {md: '580px'},
                            },
                          }}
                          onClose={() => {
                            setOpenConfJobDialog(false);
                          }}
                        >
                          <Box
                            sx={{
                              display: 'flex',
                              flexDirection: 'column',
                              gap: 3,
                              flexWrap: 'wrap',
                              pb: 2,
                              pt: 1.5,
                            }}
                          >
                            <Box
                              sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                flexWrap: 'wrap',
                                gap: 1,
                              }}
                            >
                              <Typography
                                variant="subtitle3"
                                sx={{
                                  lineHeight: '16px',
                                  color: '#333333',
                                }}
                              >
                                What is a confidential job?
                              </Typography>
                              <Typography
                                variant="body3"
                                letterSpacing="0.5px"
                                sx={{
                                  lineHeight: '16px',
                                  color: '#7E7E7E',
                                }}
                              >
                                A confidential job is one where the hiring
                                company chooses not to reveal its name publicly.
                                This is usually done for sensitive roles,
                                leadership transitions, or strategic hires that
                                require discretion.
                              </Typography>
                            </Box>
                            <Box
                              sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                flexWrap: 'wrap',
                                gap: 1,
                              }}
                            >
                              <Typography
                                variant="subtitle3"
                                sx={{
                                  lineHeight: '16px',
                                  color: '#333333',
                                }}
                              >
                                Why is the company name hidden?
                              </Typography>
                              <Typography
                                variant="body3"
                                letterSpacing="0.5px"
                                sx={{
                                  lineHeight: '16px',
                                  color: '#7E7E7E',
                                }}
                              >
                                Companies may post jobs confidentially to avoid
                                alerting internal teams, competitors, or
                                clients. It’s a common approach for leadership
                                changes or new roles tied to future business
                                plans. In most cases, the company name is shared
                                once your profile is shortlisted or during the
                                interview process.
                              </Typography>
                            </Box>
                            <Box
                              sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                flexWrap: 'wrap',
                                gap: 1,
                              }}
                            >
                              <Typography
                                variant="subtitle3"
                                sx={{
                                  lineHeight: '16px',
                                  color: '#333333',
                                }}
                              >
                                Can I trust a confidential job?
                              </Typography>
                              <Typography
                                variant="body3"
                                sx={{
                                  lineHeight: '16px',
                                  color: '#7E7E7E',
                                }}
                                letterSpacing="0.5px"
                              >
                                Yes — all confidential jobs on iimjobs.com are
                                posted by verified employers or recruiters.
                                These listings are manually reviewed by our team
                                for quality and authenticity. Your application
                                is only visible to the authorized recruiter or
                                company.
                              </Typography>
                            </Box>
                          </Box>
                        </DialogWithBottomSheet>

                        {jobInfo?.introText ? (
                          <>
                            <Box
                              sx={{
                                fontSize: 14,
                                '& p': {
                                  my: 0,
                                },
                                '& p:last-of-type': isBranded
                                  ? {
                                      display: 'inline',
                                    }
                                  : {},
                              }}
                            >
                              <div
                                dangerouslySetInnerHTML={{
                                  __html: ABDesc || '',
                                }}
                              />

                              {isBranded &&
                                jobInfo?.introText?.length > 1200 && (
                                  <Typography
                                    component="span"
                                    sx={{
                                      color: 'primary.main',
                                      cursor: 'pointer',
                                      fontSize: 14,
                                      fontWeight: 500,
                                      ml: 0.5,
                                      whiteSpace: 'nowrap',
                                    }}
                                    onClick={() => {
                                      const scrollY = window.scrollY;

                                      toggleExpand();
                                      setABDesc(
                                        !expanded
                                          ? jobInfo?.introText
                                          : jobInfo?.introText
                                              .substr(0, 1200)
                                              .trim()
                                      );

                                      if (!expanded) {
                                        requestAnimationFrame(() => {
                                          window.scrollTo({
                                            top: scrollY,
                                            behavior: 'auto',
                                          });
                                        });
                                      }
                                    }}
                                  >
                                    {expanded ? 'Read less' : 'Read more'}
                                  </Typography>
                                )}
                            </Box>
                          </>
                        ) : (
                          <Box>
                            {[...new Array(25)].map((p, i) => (
                              <Typography
                                variant="body1"
                                key={`jobdetail-body-skel-${i}`}
                              >
                                <Skeleton />
                              </Typography>
                            ))}
                          </Box>
                        )}
                      </Grid>
                      <Diversity />
                      {jobInfo.diversity && false && (
                        <Grid item xxs={12}>
                          <ImageThumbnail
                            title="Diversity Initiatives "
                            subTitle="Inclusion Network: Shine Network"
                            actionLabel="See More"
                            actionUrl={jobInfo?.diversity?.['diversityUrl']}
                            variant={VersionVariants.VERSION_TWO}
                          />
                        </Grid>
                      )}
                      {/* {email && !(videoPath || audioPath) && (
                        <Grid item xxs={12}>
                          <Alert
                            variant={VersionVariants.VERSION_TWO}
                            // severity="warning"
                            actionLabel="Create Video Profile"
                            actionUrl={getOldLink(
                              '/registration/roundzero.php?ref=jd_ab'
                            )}
                            show={true}
                            icon={
                              <Avatar
                                sx={{width: 60, height: 60, borderWidth: '4px'}}
                                badge={
                                  <Image
                                    src={Video}
                                    width={20}
                                    height={20}
                                    alt=""
                                  />
                                }
                              />
                            }
                          >
                            <Typography
                            variant="subtitle2"
                            color="text.primary"
                            >
                            Recruiters are more likely to notice applications
                            with a Video/Audio profile. <br />
                            Create one now. It’s absolutely free and easy!
                            </Typography>
                          </Alert>
                        </Grid>
                      )} */}
                      {jobInfo &&
                        jobInfo?.id &&
                        isBranded &&
                        getJobOverViewCard({xxs: 'flex', md: 'none'})}
                      {(!isBranded || !isLargeDevice) && getApplyBottom()}
                    </Grid>
                  </Card>
                  {isBranded ? (
                    <>
                      {isSmall && (
                        <Typography
                          component={'p'}
                          textAlign={{xxs: 'left', md: 'right'}}
                          color={'text.secondary'}
                          variant="body3"
                          pr={{xxs: 0, md: 2}}
                          pl={{xxs: 2, md: 0}}
                          mt={1}
                          mb={1}
                        >
                          Didn’t find the job appropriate?{' '}
                          <Typography
                            sx={{cursor: 'pointer'}}
                            onClick={() => setOpenReportJob(true)}
                            component={'b'}
                            color={'text.primary'}
                            variant="subtitle3"
                          >
                            Report this Job
                          </Typography>
                        </Typography>
                      )}
                      <Box sx={{mt: {xxs: 1, md: 1.5}}}>
                        {brandedData?.aboutCompany?.visibility && (
                          <Box ref={aboutCompanyRef}>
                            <AboutUsSection
                              isAppIimjobs={isAppIimjobs}
                              aboutCompany={brandedData?.aboutCompany || {}}
                              url={jobInfo?.showcase?.showcaseUrl || ''}
                              templateInfo={brandedData?.templateInfo}
                              sourceAttr={
                                brandedData?.sourceAttribution
                                  ?.sourceAttributionText
                              }
                              jobInfo={jobInfo}
                              jdQueryParams={jdQueryParams}
                            />
                          </Box>
                        )}

                        {jobInfo && jobInfo?.id && (
                          <Box
                            ref={companyJobsRef}
                            sx={{display: {xxs: 'block', md: 'none'}}}
                          >
                            {getCompanyJobs()}
                          </Box>
                        )}
                        {brandedData?.clients?.visibility && (
                          <Box
                            ref={clientRef}
                            sx={{display: {xxs: 'block', md: 'none'}}}
                          >
                            {getClients()}
                          </Box>
                        )}

                        {brandedData?.keyHighlights?.visibility && (
                          <Box
                            ref={companyHighlightsRef}
                            sx={{display: {xxs: 'block', md: 'none'}}}
                          >
                            {getHighLights()}
                          </Box>
                        )}

                        {brandedData?.hiringTrends?.visibility && (
                          <Box
                            ref={InsightsRef}
                            sx={{display: {xxs: 'block', md: 'none'}}}
                          >
                            {getInsights()}
                          </Box>
                        )}

                        {brandedData?.awardsRecognitions?.visibility && (
                          <Box
                            ref={companyAwardsRef}
                            sx={{display: {xxs: 'block', md: 'none'}}}
                          >
                            {getAwardsCard()}
                          </Box>
                        )}
                        {brandedData?.benefits?.visibility && (
                          <Box
                            ref={companyBenefitsRef}
                            sx={{display: {xxs: 'block', md: 'none'}}}
                          >
                            {getVerifiedBenefitsCard()}
                          </Box>
                        )}
                        {brandedData?.reviews?.visibility && (
                          <Box
                            ref={companyReviewsRef}
                            sx={{display: {xxs: 'block', md: 'none'}}}
                          >
                            {getCompanyReview()}
                          </Box>
                        )}
                      </Box>
                    </>
                  ) : (
                    <></>
                  )}
                  {!(isBranded && isSmall) && (
                    <Typography
                      component={'p'}
                      textAlign={{xxs: 'left', md: 'right'}}
                      color={'text.secondary'}
                      variant="body3"
                      pr={{xxs: 0, md: 2}}
                      pl={{xxs: 2, md: 0}}
                      mt={isBranded ? 0 : 1}
                      mb={1}
                    >
                      Didn’t find the job appropriate?{' '}
                      <Typography
                        sx={{cursor: 'pointer'}}
                        onClick={() => deferTask(() => setOpenReportJob(true))}
                        component={'b'}
                        color={'text.primary'}
                        variant="subtitle3"
                      >
                        Report this Job
                      </Typography>
                    </Typography>
                  )}
                </Box>

                <Grid
                  item
                  xxs={12}
                  display={'flex'}
                  flexWrap={'nowrap'}
                  flexDirection={'column'}
                  gap={2}
                  mb={2}
                >
                  {(saved || router.query.action === 'saved') && (
                    <Alert
                      variant={VersionVariants.VERSION_TWO}
                      title="Job saved Successfully!"
                      show={true}
                      onClose={() => setSaved(false)}
                    >
                      <Link
                        href={getOldLink('/saved-jobs')}
                        target="__blank"
                        sx={{textDecoration: 'none'}}
                      >
                        <Typography fontSize={'12px'} fontWeight={500}>
                          View all saved jobs
                        </Typography>
                      </Link>
                    </Alert>
                  )}
                  {/* {jobInfo?.showcase?.showcaseUrl && (
                    <Alert
                      variant={VersionVariants.VERSION_TWO}
                      severity="warning"
                      actionLabel="Know More"
                      actionUrl={jobInfo.showcase.showcaseUrl}
                      show={true}
                      icon={
                        <Typography
                          color={'#FFC048'}
                          lineHeight={0}
                          fontSize={{xxs: 32}}
                        >
                          <BiSolidErrorCircle />
                        </Typography>
                      }
                    >
                      <Typography variant="subtitle2" color="text.secondary">
                        Beware of fraudsters, fake jobs!{' '}
                        <Typography
                          variant="subtitle2"
                          component={'b'}
                          color={'text.primary'}
                        >
                          {jobInfo.companyData.companyName}
                        </Typography>{' '}
                        never seek money for any kind of recruitment.
                      </Typography>
                    </Alert>
                  )} */}
                </Grid>
              </>
            ) : (
              <Box my={2}>
                <JobDetailEmpty />
              </Box>
            )}

            {showSurvey && (
              <Box
                minHeight={117}
                bgcolor={'prompt.background'}
                mb={5}
                border={'1px solid'}
                borderColor={'prompt.main'}
                borderRadius={5}
                boxShadow={'0px 6.48px 6px 0px #29292914'}
                position={'relative'}
                overflow={'hidden'}
                display={'flex'}
                flexDirection={'column'}
                alignItems={'flex-start'}
                justifyContent={'center'}
                sx={{
                  px: {xs: 1.5, lg: 4},
                  py: 2,
                }}
              >
                <Box
                  position="absolute"
                  right={0}
                  top={0}
                  bottom={0}
                  margin={'auto'}
                  height={'200%'}
                >
                  <Image
                    src={SurveyBackground}
                    width={430}
                    height={340}
                    alt=""
                  />
                </Box>
                <Box
                  display={isLargeDevice ? 'flex' : 'none'}
                  position="absolute"
                  right={8}
                  top={8}
                  margin={'auto'}
                >
                  <Image src={SurveyImg} width={216} height={129} alt="" />
                </Box>
                <Survey
                  questions={surveyQuestions}
                  setShowSurvey={setShowSurvey}
                  primaryColor={'prompt.main'}
                  surveyTextColor={'prompt.dark'}
                  source={'JD'}
                  surveyType="VideoJD"
                  surveyPosition={0}
                  currQuestion={currQuestion}
                  setCurrentQuestion={setCurrQuestion}
                />
              </Box>
            )}

            <Grid item xxs={12}>
              {(jobFeedStore.jobfeed.length ||
                jobFeedStore.isLoading == true) &&
              !showLinkedInBanner &&
              !isBranded ? (
                <JobfeedHarness
                  onLoadMore={() => {}}
                  routeToJobDetail={routeToJobDetail}
                  title={'Similar jobs that you might be interested in'}
                  feedOnly={true}
                  infiniteScroll={false}
                  injectAsChild={true}
                  showFreeProBannerToday={showFreeProBannerToday}
                  variant={variant}
                  onJobSave={onJobFeedSave}
                />
              ) : (
                ''
              )}
            </Grid>
          </>
        </Grid>
        <Grid
          item
          md={3.5}
          lg={3.2}
          width={'100%'}
          zIndex={isBranded ? 10 : 'auto'}
        >
          {jobInfo &&
            jobInfo?.id &&
            getJobOverViewCard({xxs: 'none', md: 'block'})}
          {!isBranded ? (
            <>
              {' '}
              <AdsPanelHarness
                variant={variant}
                showSmallBadges={false}
                showFeatured={showFeatured}
                showLearning={showLearning}
                showLearningCenterCTA={true}
                page={JOBDETAIL}
              />
              <DownloadAppJobdetail sendEvent={sendEvent} />
            </>
          ) : (
            <>
              {jobInfo && jobInfo?.id && (
                <Box sx={{display: {xxs: 'none', md: 'block'}}}>
                  {getCompanyJobs()}
                </Box>
              )}
              {brandedData?.clients?.visibility && (
                <Box sx={{display: {xxs: 'none', md: 'block'}}}>
                  {getClients()}
                </Box>
              )}
              {brandedData?.keyHighlights?.visibility && (
                <Box sx={{display: {xxs: 'none', md: 'block'}}}>
                  {getHighLights()}
                </Box>
              )}
              {brandedData?.hiringTrends?.visibility && (
                <Box sx={{display: {xxs: 'none', md: 'block'}}}>
                  {getInsights()}
                </Box>
              )}
              {brandedData?.awardsRecognitions?.visibility && (
                <Box sx={{display: {xxs: 'none', md: 'block'}}}>
                  {getAwardsCard()}
                </Box>
              )}
              {brandedData?.benefits?.visibility && (
                <Box sx={{display: {xxs: 'none', md: 'block'}}}>
                  {getVerifiedBenefitsCard()}
                </Box>
              )}
              {brandedData?.reviews?.visibility && (
                <Box sx={{display: {xxs: 'none', md: 'block'}}}>
                  {getCompanyReview()}
                </Box>
              )}
            </>
          )}
        </Grid>

        {!jobInfo?.applied && email && (
          <ApplyJobDialog
            open={applyJobDialogState}
            variant={VersionVariants.VERSION_TWO}
            onClose={() => setApplyJobDialogState(false)}
            onApply={applyJobDialogCallback}
            refInfo={refInfo}
            confidential={jobInfo?.confidential}
            onChange={(d: {attachCover: boolean}) => {
              applyJobDialogFormData = {...applyJobDialogFormData, ...d};
            }}
          />
        )}
        {openReportJob && (
          <ReportJobDialog
            open={openReportJob}
            onClose={() => setOpenReportJob(false)}
          />
        )}

        {/* {openResumeBanner && (
          <ResumePopup
            open={openResumeBanner}
            handleCTA={() => {
              console.log('Handled Called');
              setResumeBannerSuccess(true);
            }}
            onClose={() => setOpenResumeBanner(false)}
          />
        )} */}
        {openResumeBanner && (
          <ProfileUpdateModal
            isJobFeed={false}
            handleForceBannerClose={() => {
              setOpenResumeBanner(false);
            }}
            forceEnable={openResumeBanner}
          />
        )}

        {loginOpen && (
          <Dialog
            title="Login to your account"
            subtitle="Welcome back! 👋"
            invertedTitle
            variant={VersionVariants.VERSION_TWO}
            open={loginOpen}
            onClose={() => deferTask(() => setLoginOpen(false))}
          >
            <LoginForm
              onSuccess={onLoginSuccess}
              variant={VersionVariants.VERSION_TWO}
            />
          </Dialog>
        )}

        {insightsOpen && (
          <InsightsModal
            handleClose={() => setInsightsOpen(false)}
            open={insightsOpen}
            variant={VersionVariants.VERSION_TWO}
            proUser={isPro}
            proMeta={proMembership?.insightsBanner}
            setOpenConfJobDialog={setOpenConfJobDialog}
          />
        )}
        {showLinkedInBanner && (
          <Box ml={3}>
            <LinkedInBottomSheetComponent
              title="This job is listed on iimjobs"
              subtitle="Find 50K+ exclusive roles inside the iimjobs app"
              cross={true}
              link="https://iimjobs.onelink.me/TyLF/tzdkrn70"
            />
          </Box>
        )}
      </Grid>
      {isBranded && isLargeDevice && (
        <Box
          sx={{
            position: 'fixed',
            bottom: 0,
            left: 0,

            bgcolor: 'var(--Colors-Alice-Blue-500, #F3F7FA);',
            border: '1px solid var(--Colors-Alice-Blue-500, #F3F7FA)',
            boxShadow:
              '0 2px 2px 0 rgba(0, 0, 0, 0.08), 0 6.48px 6px 0 rgba(41, 41, 41, 0.06) inset;',
            borderTopLeftRadius: 16,
            borderTopRightRadius: 16,
            p: 2,
            py: 2.5,
            zIndex: 1200,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: '100%',
          }}
        >
          <Box
            display={'flex'}
            justifyContent={'space-between'}
            sx={{
              maxWidth: 1440,

              width: '100%',
            }}
          >
            <Box display={'flex'} alignItems={'center'}>
              <Box
                borderRadius={4}
                height={50}
                width={50}
                sx={{
                  '.joblist__logo': {
                    borderRadius: 2,
                    overflow: 'hidden',
                    background: jobInfo?.companyData?.companyLogoFilePath
                      ? '#fff'
                      : 'auto',
                    boxShadow: 2,
                    border: '0.6px solid #7E7E7E33',
                  },
                }}
              >
                {jobInfo?.companyData?.companyLogoFilePath ? (
                  <ImageWithFallback
                    className="joblist__logo"
                    src={jobInfo?.companyData?.companyLogoFilePath ?? ''}
                    fallback={
                      jobInfo?.recruiter?.centralizedCompanyId &&
                      !jobInfo?.confidential
                        ? `${process.env.NEXT_PUBLIC_S3_COMPANY_LOGO_BUCKET}${jobInfo?.recruiter?.centralizedCompanyId}.webp`
                        : ''
                    }
                    placeholder="blur"
                    blurDataURL={`${process.env.NEXT_PUBLIC_S3_COMPANY_LOGO_BUCKET}${jobInfo?.recruiter?.centralizedCompanyId}.webp`}
                    alt={
                      `${jobInfo?.companyData?.companyName?.replace(
                        /\s+/g,
                        ''
                      )}_logo'` || ''
                    }
                    width={50}
                    height={50}
                    object-fit="cover"
                    quality={50}
                    // placeholder="blur"
                    itemId={jobInfo?.id}
                    // loader={imageLoader}
                  />
                ) : (
                  <Box
                    className="joblist__logo"
                    sx={{
                      background: randomColor,
                      p: 1.5,

                      height: 'min-content',
                      lineHeight: 0,
                    }}
                  >
                    <Image
                      src={DefaultJobLogo}
                      alt={'Logo'}
                      width={26}
                      height={26}
                      objectFit="cover"
                      quality={50}
                    />
                  </Box>
                )}
              </Box>
              <Box ml={1}>
                <Typography
                  sx={{
                    fontSize: 16,
                    fontWeight: 500,
                    display: '-webkit-box',
                    WebkitLineClamp: 1, // change to 2 if you want two-line truncation
                    WebkitBoxOrient: 'vertical',
                    overflow: 'hidden',
                  }}
                >
                  {jobInfo?.title.split('(')[0]}
                </Typography>
                <Box display={'flex'} alignItems={'center'} flexWrap={'wrap'}>
                  <Box display="flex" alignItems="center">
                    <Typography
                      sx={{fontSize: 14, color: '#7E7E7E', fontWeight: 500}}
                    >
                      {`${jobInfo?.min} - ${jobInfo?.max} yrs`}{' '}
                    </Typography>
                  </Box>
                  <Box
                    display="flex"
                    alignItems="center"
                    sx={{
                      width: {
                        xxs:
                          !jobInfo?.hideSal &&
                          (jobInfo?.minSal || jobInfo?.maxSal)
                            ? '100%'
                            : 'auto',
                        md: 'auto',
                      },
                      mt: {
                        xxs:
                          !jobInfo?.hideSal &&
                          (jobInfo?.minSal || jobInfo?.maxSal)
                            ? 0.5
                            : 0,
                        md: 0,
                      },
                    }}
                  >
                    {salaryString && (
                      <>
                        <Image
                          src={Dot}
                          width={4}
                          height={4}
                          alt="."
                          style={{margin: '2px 8px'}}
                        />
                        <Box sx={{display: 'flex', alignItems: 'center'}}>
                          <Image
                            src={RupeeGrey}
                            alt="rupee"
                            width={15}
                            height={15}
                            style={{
                              marginRight: 1,
                            }}
                          />
                          <Typography
                            sx={{
                              fontSize: 14,
                              color: '#7E7E7E',
                              fontWeight: 500,
                            }}
                          >
                            <Box
                              component="span"
                              sx={{display: 'inline-block'}}
                            >
                              {salaryString}
                            </Box>
                          </Typography>
                        </Box>
                        <Box
                          display={{xxs: 'none', md: 'flex'}}
                          alignItems="center"
                        >
                          <Image
                            src={Dot}
                            alt="."
                            width={4}
                            height={4}
                            style={{margin: '0 8px'}}
                          />
                        </Box>
                        <Box
                          sx={{
                            flexBasis: '100%',
                            height: 0,
                            display: {md: 'none'},
                            mt: '6px',
                          }}
                        />
                      </>
                    )}

                    {!salaryString && (
                      <Image
                        src={Dot}
                        width={4}
                        height={4}
                        alt="."
                        style={{margin: '2px 8px'}}
                      />
                    )}
                    <Typography
                      sx={{
                        fontSize: 14,
                        color: '#7E7E7E',
                        fontWeight: 500,
                      }}
                    >
                      {getLocationString(jobInfo?.locations)}
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </Box>
            <Box minWidth={545}>{getApplyBottom(true)}</Box>
          </Box>
        </Box>
      )}
    </>
  );
};

export default JobDetail;
